import FileIcon from "lib/assets/svg/file";
import FilePenIcon from "lib/assets/svg/file-pen";
import HomeIcon from "lib/assets/svg/home";
import MagnifyingGlassIcon from "lib/assets/svg/magnifying-glass";
import PhoneIcon from "lib/assets/svg/phone";
import UploadIcon from "lib/assets/svg/upload";
import UserIcon from "lib/assets/svg/user";
import IdCardIcon from "lib/assets/svg/id-card";
import BookIcon from "lib/assets/svg/book-open";
import { FEATURE_FLAGS } from "config/feature-flags";

export const menu = [
  {
    name: "Home",
    link: "/",
    icon: HomeIcon,
    beta: false,
    isProtected: false, // Public menu item
    isCommonRoute: true, // Common route for all users
  },
  {
    name: "Blog",
    link: "/blog",
    icon: BookIcon,
    beta: false,
    isProtected: false, // Public menu item
    isCommonRoute: true, // Common route for all users
  },
  {
    name: "Register",
    link: "/register",
    icon: FilePenIcon,
    beta: false,
    isProtected: false, // Public menu item
    onlyNonAuth: true, // Hide if user is logged in
  },
  {
    name: "Login",
    link: "/login",
    icon: FileIcon,
    beta: false,
    isProtected: false, // Public menu item
    onlyNonAuth: true, // Hide if user is logged in
  },
  {
    name: "My Profile",
    link: "/profileedit",
    icon: UserIcon,
    beta: false,
    isProtected: true, // Protected menu item
  },
  {
    name: "Dashboard",
    link: "/dashboard",
    icon: IdCardIcon,
    beta: false,
    isProtected: true, // Protected menu item
  },
  {
    name: "Search Profile",
    link: "/search-profiles",
    icon: MagnifyingGlassIcon,
    beta: false,
    isProtected: true, // Protected menu item
  },
  {
    name: "Contact Us",
    link: "/contact-us",
    icon: PhoneIcon,
    isProtected: false, // Public menu item
    isCommonRoute: true, // Common route for all users
  },
  {
    name: "Quick Upload",
    link: "/quick-upload",
    icon: UploadIcon,
    isProtected: false, // Public menu item
    isCommonRoute: true, // Common route for all users
  },
];

export const subMenu = [
  {
    name: "Account Information",
    link: "/account",
    icon: UserIcon,
    beta: false,
    isProtected: true, // Protected menu item
  },
  ...(FEATURE_FLAGS.ENABLE_PREFERENCE
    ? [
        {
          name: "Preferences",
          link: "/preference",
          icon: MagnifyingGlassIcon,
          beta: false,
          isProtected: true, // Protected menu item
        },
      ]
    : []),
];
